import { ChronoIcon } from "@images/svgIcons/chronoIcon"
import { ForTimeIcon } from "@images/svgIcons/forTimeIcon"
import { TrashIcon } from "@images/svgIcons/trashIcon"
import { displayTotalTime } from "@modules/chrono/chronoUtils"
import { word } from "@modules/core/utils/i18n"
import { RecapBloc } from "@modules/sessionBlock/exercises/components/RecapDetailAllChronos/recapBloc"
import {
  convertChronoFormikToChronoDraft,
  ExerciseFormikType,
} from "@modules/sessionBlock/exercises/exerciseFormikTypes"
import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { useMemo } from "react"
import { useTheme } from "styled-components"

export const FortimeRecap: React.FC = () => {
  const { formik, updatedBlockIndex } = useSessionFormContext()
  const theme = useTheme()

  const displayChronoTime = useMemo(() => {
    if (updatedBlockIndex === null) return ""

    const chronoDraft = convertChronoFormikToChronoDraft(
      formik.values.blocks[updatedBlockIndex].content as ExerciseFormikType,
    )

    if (chronoDraft === undefined) return word("chrono.title.no_chrono")

    return displayTotalTime(chronoDraft)
  }, [formik.values.blocks, updatedBlockIndex])

  if (updatedBlockIndex === null) return <></>

  const formikValue = formik.values.blocks[updatedBlockIndex].content as ExerciseFormikType
  const formikNameBase = `blocks[${updatedBlockIndex}].content`

  const onDeleteChronoClick = () => {
    formik.setFieldValue(`${formikNameBase}.chronoForTime`, undefined)
    formik.setFieldValue(`${formikNameBase}.chrono`, undefined)
    formik.setFieldValue(`${formikNameBase}.chronoType`, undefined)
  }

  return (
    <>
      <div className="flex flex-row align-items-start justify-content-between mb-2">
        <ForTimeIcon color={theme.mainWhite} />

        <div className="flex flex-column align-items-center">
          <HUText fontStyle="LS">{word("chrono.title.for_time")}</HUText>

          <div className="flex align-items-center">
            <ChronoIcon color={theme.buttonPrimaryTextColor} />
            <HUText className="ml-2" fontStyle="TL">
              {displayChronoTime}
            </HUText>
          </div>
        </div>

        <HUButton
          type="Rounded"
          size="XS"
          colorType="Secondary"
          icon={{ iconView: <TrashIcon color={theme.textPrimary} width={22} height={22} /> }}
          onClick={onDeleteChronoClick}
          className="bg-transparent hover:surface-200"
        />
      </div>

      {formikValue.chronoForTime?.trainingTime && (
        <>
          <div className="flex align-items-center justify-content-between mb-2 gap-2">
            {formikValue.chronoForTime.numberOfSets > 1 && (
              <RecapBloc
                setsIcon
                value={`${formikValue.chronoForTime.numberOfSets} ${word("global.score.set.unit", { count: formikValue.chronoForTime.numberOfSets })}`}
              />
            )}
            <RecapBloc
              playIcon
              infinityIcon={formikValue.chronoForTime.noLimit}
              value={formikValue.chronoForTime.noLimit ? "" : formikValue.chronoForTime.trainingTime}
            />
          </div>
          {formikValue.chronoForTime.numberOfSets > 1 && (
            <div className="flex align-items-center justify-content-between mb-2 gap-2">
              <RecapBloc
                circleBreakIcon
                value={`${formikValue.chronoForTime.restTime} ${word("chrono.settings.label.rest_between_sets_short")}`}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}
